const plus = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13%2011h9v2h-9v9h-2v-9H2v-2h9V2h2z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  plus as default
};
//# sourceMappingURL=plus.svg.es.js.map
